import V2Adapter from './v2';

export default class GroupInviteLinkAdapter extends V2Adapter {
  shouldBackgroundReloadRecord() {
    return false;
  }

  pathForType() {
    return 'guest-group-invite-links';
  }

  // Customized to allow for `store.queryRecord('group-invite-link', { id: 'current' })`
  // to be used to fetch the token-authenticated group invite link.
  urlForQueryRecord(query, modelName) {
    const url = super.urlForQueryRecord(query, modelName);

    if (modelName === 'group-invite-link' && query['id'] === 'current') {
      delete query['id'];
      return `${url}/current`;
    } else {
      return url;
    }
  }
}
